module.exports = require("@seddi/scene-builder");